import { useCallback } from 'react';

import { useQueryStateContext } from '../../contexts/queryState';
import { EditableCriteria } from '../../types';
import { useQueryHistoryStateContext } from '../../contexts/queryHistory';

export const useQueryCriteriasState = () => {
  const {
    query: { searchQueries: criterias },
    setQuery,
  } = useQueryStateContext();

  const { addToUndoStack } = useQueryHistoryStateContext();

  const setCriterias = useCallback(
    (setterFn: (currentCriterias: EditableCriteria[]) => EditableCriteria[]) => {
      setQuery((query) => ({ ...query, searchQueries: setterFn(query.searchQueries) }));
      addToUndoStack();
    },
    [setQuery, addToUndoStack],
  );
  return { criterias, setCriterias };
};
